import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/local_life",
  component: function component() {
    return import("../../../views/local_life/index.vue");
  },
  name: "local_life",
  meta: {
    title: "首页",
    foot: true
  }
}, {
  path: "/local_life_search",
  component: function component() {
    return import("../../../views/local_life/search.vue");
  },
  name: "local_life_search",
  meta: {
    title: "搜索",
    foot: true
  }
}, {
  path: "/local_life_order_details/:order_id?",
  component: function component() {
    return import("../../../views/local_life/orderDetails/orderDetails.vue");
  },
  name: "local_life_order_details",
  meta: {
    title: "订单详情",
    foot: true
  }
}, {
  path: "/local_life_store_details/:store_id?",
  component: function component() {
    return import("../../../views/local_life/store/details.vue");
  },
  name: "local_life_store_details",
  meta: {
    title: "门店详情",
    foot: true
  }
}, {
  path: "/local_life_photo_album/:store_id?",
  component: function component() {
    return import("../../../views/local_life/store/photo.vue");
  },
  name: "local_life_photo_album",
  meta: {
    title: "门店详情",
    foot: true
  }
}, {
  path: "/local_life_duscounts/:store_id?",
  component: function component() {
    return import("../../../views/local_life/store/discounts.vue");
  },
  name: "local_life_duscounts",
  meta: {
    title: "全部优惠",
    foot: true
  }
}, {
  path: "/local_life_store/:store_id?",
  component: function component() {
    return import("../../../views/local_life/store/index.vue");
  },
  name: "local_life_store",
  meta: {
    title: "门店",
    foot: true
  }
}, {
  path: "/local_life_publish_comment/:store_id?",
  component: function component() {
    return import("../../../views/local_life/publish_comment.vue");
  },
  name: "local_life_publish_comment",
  meta: {
    title: "评论",
    foot: true
  }
}, {
  path: "/local_life_comment/:store_id?",
  component: function component() {
    return import("../../../views/local_life/comment.vue");
  },
  name: "local_life_comment",
  meta: {
    title: "全部评价",
    foot: true
  }
}, {
  path: "/local_life_apply_store/:goods_id?",
  component: function component() {
    return import("../../../views/local_life/apply_store.vue");
  },
  name: "local_life_apply_store",
  meta: {
    title: "适用门店",
    foot: true
  }
}, {
  path: "/local_life_goods/:goods_id?",
  component: function component() {
    return import("../../../views/local_life/goods.vue");
  },
  name: "local_life_goods",
  meta: {
    title: "商品详情",
    foot: true
  }
}];